import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=38f355db&"
import script from "./UploadModal.vue?vue&type=script&lang=js&"
export * from "./UploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports